class ReturnsController {
    static $inject = ["$q", "$location", "stToast", "tpsrService"];

    constructor($q, $location, stToast, tpsrService) {
        this.$q = $q;
        this.$location = $location;
        this.toast = stToast;
        this.tpsr = tpsrService;
        this.user = null;
        this.order = {
            lines: []
        }
    }

    $onInit() {
        if (this.orderId)
            return this.$q.all(
                this._loadOrder(this.orderId),
            );
        else if (this.userId)
            return this.$q.all(
                this._loadUser(this.userId),
            );
    }

    returnTotalQuantity = () => this.order.lines.reduce((s, l) => s + l.return_quantity, 0);

    createReturnClicked = () => {
        const request = {
            order: {
                user_id: this.order.user_id,
                order_id: this.orderId,
            },
            lines: []
        };
        this.order.lines.forEach(item => {
            if (item.return_quantity > 0) {
                request.lines.push({
                    PIMS_item_id: item.PIMS_item_id,
                    return_quantity: item.return_quantity,
                    return_lot_no: item.lot_no,
                    replace_quantity: item.replace_quantity,
                    Unit_Of_Measure: item.uom
                });
            }
        });

        return this.tpsr.createReturn(request).then(result => {
            if (result.success) {
                this.toast.success("Return Created", `Return created for order ${this.order.order_id}.`)
                this.$location.url(`/orders/${this.orderId}?ref=return-created&rid=${result.return_id}`);
            }
        });
    }

    cancelClicked = () => {
        this.$location.url(`/orders/${this.orderId}`);
    };

    _loadOrder = order_id => {
        return this.tpsr.getOrder(order_id).then(result => {
            this.order = result;
            this.order.lines.length = 0;
            this.order.lines = this.order.shipments.reduce((out, s) => {
                s.lines.forEach(sl => {
                    let ol = out.find(o => o.lot_no === sl.lot_no);
                    if (!ol) {
                        out.push(sl);
                    } else {
                        ol.quantity = ol.quantity + sl.quantity;
                    }
                });
                return out;
            }, []);
            console.log(this.order);
            this.order.lines.forEach(l => {
                l.return_quantity = 0;
                l.replace_quantity = 0;
            });
        });
    };

    _loadUser = user_id => {
        return this.tpsr.getUser(user_id).then(result => {
            this.user = result;
            this.order.user_id = user_id;
            return this._loadItems();
        });
    };

    _loadItems = () => {
        return this.tpsr.getItems(this.user.PIMS_customer_id).then(result => {
            this.order.lines = result;
            this.order.lines.forEach(i => {
                i.quantity = 0;
                l.return_quantity = 0;
                l.replace_quantity = 0;
                i.lot_no = null;
            });
        });
    };
}

angular
    .module("app")
    .component("returns", { // returns
        bindings: {
            orderId: "<",
            userId: "<"
        },
        templateUrl: "src/app/returns/returns.html",
        controller: ReturnsController
    });
